var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecurring(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.85535 19.7568C5.79107 18.7997 5.0233 17.6523 4.52029 16.4203C3.18597 13.1526 3.81077 9.26622 6.41587 6.58543L8.81977 8.98598C8.95214 9.11817 9.19041 9.02299 9.22218 8.82735L10.5353 0.24563C10.5565 0.102866 10.4347 -0.0187483 10.2918 0.00240196L1.6928 1.31372C1.49689 1.34544 1.40158 1.58339 1.53395 1.71557L3.94314 4.12142C-0.0333474 8.18227 -0.711098 14.2736 1.8993 19.0324C2.68295 20.4653 3.76841 21.7766 5.15038 22.8764C7.50133 24.7429 10.3924 25.6365 13.2622 25.5784L13.8023 22.0516C11.3296 22.2631 8.788 21.5017 6.85535 19.7568Z",
    fill: "#2C3E50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.8455 21.8815C26.822 17.8206 27.4997 11.7294 24.8893 6.97055C24.1057 5.53762 23.0202 4.2263 21.6382 3.12649C19.2873 1.25998 16.3963 0.366377 13.5264 0.42454L12.9863 3.95135C15.4538 3.73985 18.0006 4.50126 19.9333 6.24615C20.9975 7.2032 21.7653 8.35061 22.2683 9.58261C23.6026 12.8503 22.9778 16.7367 20.3727 19.4175L17.9689 17.0169C17.8365 16.8847 17.5982 16.9799 17.5664 17.1756L16.2533 25.7573C16.2321 25.9 16.3539 26.0217 16.4969 26.0005L25.0958 24.6892C25.2917 24.6575 25.3817 24.4195 25.2547 24.2873L22.8455 21.8815Z",
    fill: "#2C3E50"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurring);
export default __webpack_public_path__ + "static/media/recurring.9d5693502af11ecf2039e37de7c168fd.svg";
export { ForwardRef as ReactComponent };